import React, { useContext } from 'react';
import {
  arrayOf, bool, func, number, shape, string
} from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { AddToCart } from '@thd-olt-component-react/add-to-cart';
import { useLifeCycleEventBus } from '@thd-olt-functional/utils';
import { getCartOptions, getCartReqParams } from '../../BuyboxHelper';
import { useBogoInfo } from '../hooks/useBogoInfo';
import '../buybox.scss';

const BuyboxAddToCart = ({
  alterBrowserHistory,
  disableATC,
  fulfillment,
  fulfillmentMethod,
  isAssembleItemAtStore,
  itemId,
  configurableItems,
  onClickPassThrough,
  onATCClick,
  productAddOns = {},
  quantity,
  quantityLimitExceed,
  storeId,
  storeZip,
  zipCode,
  showFavoriteAndQuote
}) => {
  const { channel } = useContext(ExperienceContext);
  const bogoInfo = useBogoInfo();

  const { items } = useLifeCycleEventBus('configurator.configurator_available_items');

  const buttonText = bogoInfo?.bogoSelectedProduct?.itemId ? 'Add Both to Cart' : 'Add to Cart';
  const isSubscribeAndSaveOpted = !!productAddOns?.subscriptions?.frequency;

  return (
    <div className={!showFavoriteAndQuote ? 'buybox__atc' : 'buybox__cart-and-favorites'}>
      <AddToCart
        onClickPassThrough={onClickPassThrough}
        cartOptions={getCartOptions({
          configurableItems,
          alterBrowserHistory,
          bogoInfo,
          channel,
          fulfillmentMethod,
          storeId,
          storeZip,
          zipCode
        })}
        cartReqParams={getCartReqParams({
          bogoInfo,
          fulfillment,
          fulfillmentMethod,
          isAssembleItemAtStore,
          itemId,
          configurableItems,
          quantity,
          productAddOns,
          storeId,
          storeZip,
          zipCode
        })}
        disabled={disableATC || quantityLimitExceed}
        onClick={onATCClick}
        variant="primary"
        showIcon
      >
        {isSubscribeAndSaveOpted ? 'Subscribe' : buttonText }
      </AddToCart>
    </div>
  );
};

BuyboxAddToCart.propTypes = {
  alterBrowserHistory: bool,
  disableATC: bool,
  fulfillment: shape({
    type: string,
    locations: arrayOf(shape({
      isAnchor: bool,
      inventory: shape({
        quantity: number,
        isInStock: bool,
        isLimitedQuantity: bool,
        isBackordered: bool
      })
    }))
  }),
  fulfillmentMethod: string,
  isAssembleItemAtStore: bool,
  itemId: string.isRequired,
  configurableItems: shape({
    itemId: string,
    isAnchor: bool
  }),
  onClickPassThrough: func,
  onATCClick: func,
  productAddOns: shape({
    attachedLabor: arrayOf(shape({
      attachedLaborSku: string
    })),
    warrantyItem: shape({
      itemId: string
    })
  }),
  quantity: number,
  quantityLimitExceed: bool,
  storeId: string,
  storeZip: string,
  zipCode: string,
  showFavoriteAndQuote: bool
};

BuyboxAddToCart.defaultProps = {
  alterBrowserHistory: false,
  configurableItems: null,
  onClickPassThrough: null,
  disableATC: false,
  fulfillment: null,
  fulfillmentMethod: '',
  isAssembleItemAtStore: null,
  onATCClick: () => {},
  productAddOns: null,
  quantity: 1,
  quantityLimitExceed: false,
  storeId: null,
  storeZip: null,
  zipCode: null,
  showFavoriteAndQuote: false
};

export { BuyboxAddToCart };
